// extracted by mini-css-extract-plugin
export default {"home":"updateCourse_home__OLMZe","hr":"updateCourse_hr__I4QWp","home2":"updateCourse_home2__aSjhX","main":"updateCourse_main__R7GZP"};